import * as React from 'react'
import {connect} from "react-redux"
import {ApplicationState} from "../../store"
import {Button} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionEmployeeSave, actionEmployeeFetch} from "../../store/employees/actions"
import {actionActiveTabTitle} from "../../store/tabs/actions"
import {Tab} from '../Tab'
import {Validator} from '../../core/Validator'
import {EmployeeDescriptor, contractTypes, educationLevelTypes} from '../../models/Employee'
import {Utility} from '../../core/Utility'
import {t} from "../../core/localization"
import {Position} from "../../models/Position"
import {actionPositionFetchAll} from "../../store/positions"
import {User} from "../../models/User"
import {actionUserFetchAll} from "../../store/users"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {LookupDataRow} from "../../services/LookupDataRow"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {FieldView} from "../components/FieldView"
import {employeeFieldsDescriptor} from "./EmployeeFields"

export interface EmployeeTabProps extends BaseTabProps{
	tab: Tab
	positions: Position[]
	users: User[]
}

export interface EmployeeTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		positions: state.positions.list,
		users: state.users.list
	}
}

class EmployeeTab extends BaseTab<EmployeeTabProps, EmployeeTabState> {

	constructor(props: EmployeeTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
    }

	componentWillReceiveProps(nextProps: EmployeeTabProps) {
	}

	componentDidMount() {
		actionPositionFetchAll()
		actionUserFetchAll()
		if (this.props.item.id) actionEmployeeFetch(this.props.item)
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderFormControls()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = employeeFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={this.getLookupData.bind(this)}
								/>}
							</div>
						)
					}
				)
			}
		</div>
		)
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		switch (lookupEntity) {
			case LookupEntities.Users: {
				return this.props.users.map((user: User) => {return {label: `${user.firstName} ${user.lastName}`, value: user.id, data: user}})
			}
			case LookupEntities.Positions: {
				return this.props.positions.map((position: Position) => {return {label: `${position.title}`, value: position.id, data: position}})
			}
			case LookupEntities.EducationLevelTypes: {
				let allEducationLevelTypes = []
				for (let type in educationLevelTypes){// @ts-ignore
					allEducationLevelTypes.push(educationLevelTypes[type])
				}
				return allEducationLevelTypes.map((educationLevel: string) => {return {label: educationLevel, value: educationLevel}})
			}
			case LookupEntities.ContractTypes: {
				let allContractTypes = []
				for (let type in contractTypes){// @ts-ignore
					allContractTypes.push(contractTypes[type])
				}
				return allContractTypes.map((contractType: string) => {return {label: contractType, value: contractType}})
			}
		}
	}

	renderFormControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()

		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, EmployeeDescriptor)

		if (validation.valid) {
			actionEmployeeSave(itemToSave)
			actionActiveTabTitle(t.Employee + ': ' + this.getItemFromTabState('firstName')+ ' ' + this.getItemFromTabState('lastName'))
		}

		this.setState({ ...this.state, validation: validation });
	}
}

export default connect(mapStateToProps)(EmployeeTab);
